
import { CityData, Product, Contractor, PipelineItem } from './types';

export const getRelativeDate = (daysOffset: number) => {
    const d = new Date();
    d.setDate(d.getDate() + daysOffset);
    return d.toISOString().split('T')[0];
};

export const CONTRACTORS: Contractor[] = [
  { id: 'contractor-1', name: 'Mike Ross', role: 'Senior Tech', avatar: 'https://i.pravatar.cc/150?u=mike', email: 'mike@quikpix.co.nz', phone: '021 123 4567', hourlyRate: 45 },
  { id: 'contractor-2', name: 'Rachel Zane', role: 'Attendant', avatar: 'https://i.pravatar.cc/150?u=rachel', email: 'rachel@quikpix.co.nz', phone: '022 987 6543', hourlyRate: 30 },
  { id: 'contractor-3', name: 'Harvey Specter', role: 'Event Manager', avatar: 'https://i.pravatar.cc/150?u=harvey', email: 'harvey@quikpix.co.nz', phone: '027 555 1234', hourlyRate: 80 }
];

export const CITIES: Record<string, CityData> = {
  auckland: {
    id: 'akl',
    name: 'Auckland',
    slug: 'auckland',
    seoTitle: 'Premium Photo Booth Rental Auckland | 360 Video Booths | QuikPix NZ',
    seoDescription: 'Elevate your Auckland event with QuikPix. Offering high-end 360 video booths, AI photo experiences, and corporate branding activations in Auckland CBD and surrounding areas.',
    operatorName: 'Sarah Jenkins',
    operatorBio: 'Sarah has over 10 years of experience in the Auckland event industry. Specializing in high-end weddings and corporate galas at the Viaduct, she ensures every pixel is perfect.',
    operatorImage: 'https://picsum.photos/200/200?random=1',
    coordinates: { lat: -36.8485, lng: 174.7633 }
  },
  wellington: {
    id: 'wlg',
    name: 'Wellington',
    slug: 'wellington',
    seoTitle: 'Wellington Corporate Photo Booths & Wedding Hire | QuikPix NZ',
    seoDescription: 'The #1 choice for photo booth hire in Wellington. From Te Papa corporate functions to intimate vineyard weddings, our local team delivers cutting-edge photo experiences.',
    operatorName: 'James Tui',
    operatorBio: 'A tech enthusiast and Wellington local, James brings the latest in AI and 360 booth technology to the capital. Known for his reliability and creative setups.',
    operatorImage: 'https://picsum.photos/200/200?random=2',
    coordinates: { lat: -41.2866, lng: 174.7756 }
  },
  christchurch: {
    id: 'chc',
    name: 'Christchurch',
    slug: 'christchurch',
    seoTitle: 'Christchurch Photo Booth Hire | 360 Booths & Magic Mirrors | QuikPix',
    seoDescription: 'Transform your Christchurch event with QuikPix. Serving the Canterbury region with luxury photo booths, audio guest books, and instant social sharing capabilities.',
    operatorName: 'Emma & Liam',
    operatorBio: 'This dynamic duo runs the South Island operations. With a background in photography and logistics, they handle everything from large festivals to private parties in Christchurch.',
    operatorImage: 'https://picsum.photos/200/200?random=3',
    coordinates: { lat: -43.5321, lng: 172.6362 }
  }
};

export const PRODUCTS: Product[] = [
  {
    id: 'permanent-install',
    name: 'Permanent Installs',
    description: 'Hardware sales and leasing for Venues, Casinos, and Corporate Offices.',
    image: 'https://images.unsplash.com/photo-1576267423048-15c0040fec78?auto=format&fit=crop&q=80&w=800',
    tags: ['Sales', 'Leasing'],
    longDescription: 'Direct from our NZ manufacturing facility to your floor. We build commercial-grade photo hardware designed for permanent installation. Whether you are a bar looking for passive revenue, or a convention centre needing a fleet of sub-hire booths, we have the hardware and the software infrastructure to power it.',
    features: [
      'NZ Manufactured Hardware',
      'Enterprise Fleet Management',
      'Pay-Per-Event Billing Models',
      'Custom Fabrication Available',
      'Wall Mount & Bar Leaner Options'
    ],
    specs: {
      'Build': 'Powder-coated Steel / Wood',
      'Origin': 'Made in New Zealand',
      'Support': '24/7 Enterprise SLA',
      'Branding': 'Full Customization'
    },
    gallery: [
      { url: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=800', caption: 'Venue Installation Example' },
      { url: 'https://images.unsplash.com/photo-1574096079513-d8259312b785?auto=format&fit=crop&q=80&w=600', caption: 'Hardware Detail' }
    ]
  },
  {
    id: '360-video',
    name: '360x Video Booth',
    description: 'Cinematic slow-motion video captured from every angle. The ultimate red-carpet experience.',
    image: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?auto=format&fit=crop&q=80&w=800',
    tags: ['Video', 'Premium'],
    longDescription: 'Step onto the platform and become the star of your own music video. Our 360x Video Booth captures 120fps high-definition slow-motion footage while rotating around you. The result is a TV-quality video with custom music, animated overlays, and intro/outro bumpers tailored to your brand or event theme.',
    features: [
      'High-Resolution GoPro/DSLR Capture',
      'Instant AirDrop & QR Code Sharing',
      'Custom Animated Overlays',
      'Professional RGB Lighting Tower',
      'Red Carpet & Bollards Setup'
    ],
    specs: {
      'Space Required': '3m x 3m',
      'Power': '1x 10amp standard outlet',
      'Setup Time': '1.5 Hours',
      'Capacity': 'Up to 4 people on platform'
    },
    productionGuide: 'Please ensure a flat, level surface of at least 3m x 3m. Power access must be within 5m. Not suitable for grass or gravel without a solid sub-floor.',
    uploadFolderUrl: 'https://drive.google.com/drive/folders/batch-upload-link',
    documents: [
        { id: 'doc1', name: '360 Overlay Specs', type: 'TEMPLATE', url: '#' },
        { id: 'doc2', name: 'Safety RAMS Form', type: 'PDF', url: '#' }
    ],
    onboardingFields: [
        { id: 'song', label: 'Song Selection (Spotify Link)', type: 'text', required: true, helpText: 'Choose a high-energy track for the video soundtrack.' },
        { id: 'overlay_text', label: 'Overlay Text (Names/Date)', type: 'text', required: true, helpText: 'What text should appear on the video?' }
    ],
    gallery: [
      { url: 'https://images.unsplash.com/photo-1561489413-985b06da5bee?auto=format&fit=crop&q=80&w=800', caption: 'Guest Experience' },
      { url: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80&w=600', caption: 'Lighting Setup' },
      { url: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=600', caption: 'Platform Detail' },
      { url: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?auto=format&fit=crop&q=80&w=600', caption: 'Sample Output Frame' },
      { url: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&q=80&w=600', caption: 'Crowd Engagement' }
    ]
  },
  {
    id: 'brandpix',
    name: 'BrandPix AI',
    description: 'AI-powered background removal and instant branding overlays without a green screen.',
    image: 'https://images.unsplash.com/photo-1626785774573-4b79931b2993?auto=format&fit=crop&q=80&w=800',
    tags: ['AI', 'Corporate'],
    longDescription: 'Ditch the ugly green screen. BrandPix uses military-grade artificial intelligence to separate subjects from their background in real-time. Place your guests on the moon, inside your product, or at a destination landmark instantly. Perfect for corporate activations where floor space is at a premium but brand impact is non-negotiable.',
    features: [
      'Green Screen-Less Technology',
      'Multiple Virtual Background Selection',
      'Data Capture (Email/Phone)',
      'Live Slideshow to External TV',
      'Detailed Analytics Report'
    ],
    specs: {
      'Space Required': '2m x 2m',
      'Power': '1x 10amp standard outlet',
      'Internet': 'Required for AI processing (4G backup included)',
      'Format': 'Still Photos, Boomerangs, GIFs'
    },
    productionGuide: 'Requires reliable 4G/5G signal or venue WiFi for AI processing. Best placed away from direct sunlight.',
    onboardingFields: [
        { id: 'data_fields', label: 'Data Capture Fields', type: 'select', required: true, options: 'Email Only, Email + Phone, None', helpText: 'What data do you want to collect?' },
        { id: 'disclaimer', label: 'GDPR / Terms Disclaimer Text', type: 'textarea', required: false }
    ],
    gallery: [
      { url: 'https://images.unsplash.com/photo-1531297461136-82lw9z2l3b2?auto=format&fit=crop&q=80&w=800', caption: 'AI Background Replacement' },
      { url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=600', caption: 'Data Capture Screen' },
      { url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80&w=600', caption: 'Digital Output Example' },
      { url: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=600', caption: 'Hardware Footprint' },
      { url: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=600', caption: 'Live Sharing Station' }
    ]
  },
  {
    id: 'photostation',
    name: 'PhotoStation',
    description: 'Modern, sleek open-air photo kiosk with high-speed printing and social sharing.',
    image: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&q=80&w=800',
    tags: ['Print', 'Social'],
    longDescription: 'The classic photo booth reinvented. The PhotoStation is a beautiful, open-air kiosk that fits any venue aesthetic. Equipped with a DSLR camera and studio-quality lighting, everyone looks their best. Guests can print 4x6 photos in 8 seconds or share digitally instantly. It acts as a social hub for your party.',
    features: [
      'DSLR Quality Images',
      'Unlimited Laboratory Quality Prints',
      'Custom Print Designs',
      'Beauty Dish Lighting',
      'Online Gallery Hosting'
    ],
    specs: {
      'Space Required': '2.5m x 2.5m',
      'Power': '1x 10amp standard outlet',
      'Printer Speed': '8 seconds per print',
      'Backdrop': 'Included (Select from our range)'
    },
    productionGuide: 'We require a sturdy table for the printer if not using our podium. Access to venue 1 hour prior.',
    documents: [
        { id: 'doc1', name: 'Print Strip Templates', type: 'TEMPLATE', url: '#' }
    ],
    onboardingFields: [
        { id: 'print_template_text', label: 'Text for Print Strip', type: 'text', required: true, helpText: 'e.g. SARAH & TOM 24.02.25' },
        { id: 'backdrop_color', label: 'Backdrop Preference', type: 'select', required: true, options: 'White, Black, Gold Sequin, Silver Sequin, Green Screen' }
    ],
    gallery: [
      { url: 'https://images.unsplash.com/photo-1520854221256-17451cc330e7?auto=format&fit=crop&q=80&w=800', caption: 'Booth Setup with Backdrop' },
      { url: 'https://images.unsplash.com/photo-1544155843-a5d198c379a2?auto=format&fit=crop&q=80&w=600', caption: 'High Quality Prints' },
      { url: 'https://images.unsplash.com/photo-1519671482538-eb62635ca436?auto=format&fit=crop&q=80&w=600', caption: 'Guest Interaction' },
      { url: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&q=80&w=600', caption: 'Sample Strip Layout' },
      { url: 'https://images.unsplash.com/photo-1530103862676-de3c9da59af7?auto=format&fit=crop&q=80&w=600', caption: 'Touchscreen Interface' }
    ]
  },
  {
    id: 'roam',
    name: 'Pro Roam',
    description: 'A mobile photographer with a ring-light integration roaming the dance floor.',
    image: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?auto=format&fit=crop&q=80&w=800',
    tags: ['Mobile', 'Events'],
    longDescription: 'Why wait for guests to come to the booth? Pro Roam brings the booth to them. Our energetic operators roam the dance floor, cocktail hour, or festival grounds with a handheld, ring-light illuminated device. It captures photos, GIFs, and Boomerangs that are AirDropped instantly to guests phones.',
    features: [
      'Completely Mobile Solution',
      'Perfect for Large Venues/Festivals',
      'Instant SMS/Email Sharing',
      'Brandable Ring Light Unit',
      'Zero Footprint Required'
    ],
    specs: {
      'Space Required': 'None (Roaming)',
      'Power': 'Battery Operated',
      'Connectivity': '4G/5G Built-in',
      'Staff': '1x Brand Ambassador included'
    },
    gallery: [
      { url: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&q=80&w=800', caption: 'Roaming Experience' },
      { url: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?auto=format&fit=crop&q=80&w=600', caption: 'Instant Sharing' },
      { url: 'https://images.unsplash.com/photo-1514525253440-b393452e8d26?auto=format&fit=crop&q=80&w=600', caption: 'Dance Floor Action' },
      { url: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=600', caption: 'Handheld Unit' },
      { url: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&q=80&w=600', caption: 'Digital Delivery' }
    ]
  },
  {
    id: 'mosaix',
    name: 'Mosaix',
    description: 'Digital and physical photo mosaics created in real-time from guest photos.',
    image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&q=80&w=800',
    tags: ['Interactive', 'Large Scale'],
    longDescription: 'Build the bigger picture together. Mosaix takes photos captured at the event (or via Instagram hashtag) and uses them as "tiles" to build a massive physical or digital image. Guests place their sticker on the board to reveal the final masterpiece over the course of the event. The ultimate collaborative brand activation.',
    features: [
      'Physical Sticker Wall',
      'Digital-Only Mode Available',
      'Hashtag Printing Integration',
      'Real-time Progress Display',
      'Keepsake for Client Office'
    ],
    specs: {
      'Space Required': '3m x 2m (min)',
      'Power': '2x 10amp standard outlets',
      'Mounting': 'Easel or Wall Mount',
      'Throughput': 'High Volume'
    },
    gallery: [
      { url: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&q=80&w=800', caption: 'Completed Mosaic Wall' },
      { url: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&q=80&w=600', caption: 'Sticker Placement' },
      { url: 'https://images.unsplash.com/photo-1453728013993-6d66e9c9123a?auto=format&fit=crop&q=80&w=600', caption: 'Detail View' },
      { url: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=600', caption: 'Team Collaboration' },
      { url: 'https://images.unsplash.com/photo-1513542789411-b6a5d4f31634?auto=format&fit=crop&q=80&w=600', caption: 'Process Shot' }
    ]
  },
  {
    id: 'audio-guest',
    name: 'Audio Guest Book',
    description: 'Vintage telephone styling recording voicemails from your guests.',
    image: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&q=80&w=800',
    tags: ['Audio', 'Weddings'],
    longDescription: 'Capture the voices, laughter, and advice of your loved ones. Our Audio Guest Book looks like a stylish vintage rotary phone. Guests simply pick up the receiver, hear your pre-recorded greeting, and leave a voicemail. After the event, you receive a digital file with all the heartfelt (and often hilarious) messages.',
    features: [
      'Authentic Vintage Hardware',
      'Custom Greeting Recording',
      'Digital Delivery of Audio Files',
      'Simple "Pick Up to Record" Interface',
      'Stylish Decor Piece'
    ],
    specs: {
      'Space Required': 'Small side table',
      'Power': 'Battery Operated (No cords)',
      'Setup': 'Instant',
      'Format': '.WAV or .MP3 files'
    },
    gallery: [
      { url: 'https://images.unsplash.com/photo-1585856429302-28682705b6fa?auto=format&fit=crop&q=80&w=800', caption: 'Vintage Phone Unit' },
      { url: 'https://images.unsplash.com/photo-1563293880-92790680d226?auto=format&fit=crop&q=80&w=600', caption: 'Guest Using Phone' },
      { url: 'https://images.unsplash.com/photo-1596706788892-491383790544?auto=format&fit=crop&q=80&w=600', caption: 'Styling Example' },
      { url: 'https://images.unsplash.com/photo-1528643884877-3e5dfd35df90?auto=format&fit=crop&q=80&w=600', caption: 'Decor Setup' },
      { url: 'https://images.unsplash.com/photo-1583321500900-8244795d954d?auto=format&fit=crop&q=80&w=600', caption: 'Event Context' }
    ]
  }
];

export const SEED_CRM_DATA: PipelineItem[] = [];
